import { useEffect, useState } from "react";

/**
 * Track online/offline status via `navigator.onLine` plus the online/offline
 * events. Everything in CatalogKit works offline (all data is local); this just
 * drives the offline banner and graceful degradation of the network-only bits
 * (contact form, update checks, bug reporter).
 */
export function useOfflineStatus(): boolean {
  const [offline, setOffline] = useState<boolean>(
    typeof navigator !== "undefined" ? !navigator.onLine : false,
  );

  useEffect(() => {
    const goOnline = (): void => setOffline(false);
    const goOffline = (): void => setOffline(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return offline;
}
